module.exports = __webpack_public_path__ + "static/Montserrat-400-a8a117360e71de94ae3b0b0f8d15b44d.ttf";